import slick from 'slick-carousel';

function ensureSlick() {
  if (typeof $.fn.slick === 'function') {
    return true;
  }

  if (typeof slick === 'function') {
    slick(window, window.jQuery || $);
  }

  return typeof $.fn.slick === 'function';
}

export default (el) => {
  if (!ensureSlick()) {
    return;
  }

  const $component = $(el),
        $slider = $component.find('.features-slider-block-images'),
        $controls = $component.find('.features-slider-block-controls'),
        $textSlides = $component.find('.features-slider-block-text-slides');

  // Initialize Slick slider
  $slider.slick({
    dots: true,
    arrows: true,
    appendDots: $controls,
    appendArrows: $controls,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next"></button>',
    asNavFor: $textSlides
  });

  $textSlides.slick({
    dots: false,
    arrows: false,
    fade: true,
    asNavFor: $slider
  });
};
